export const environment = {
  production: false,

  // Build Environment
  NODE_ENV: 'production',
  // VUE_APP_BUILD_ID: 1,

  VUE_APP_GOOGLE_MAPS_KEY: 'AIzaSyAx5vxOMwxfXivvTBgJN9TAacJEEZXJlj4',

  // Recaptcha
  VUE_APP_RECAPTCHA_SITE_KEY: '6LeoX8crAAAAAP1YmeD2N_9mbGTd9L9gbVe5ajrt',

  // MapBox
  VUE_APP_MAP_BOX_KEY: 'pk.eyJ1IjoidmxhZGltaXJzaGtyb2JvdCIsImEiOiJjazk0OTJodDkwM2IwM2duM2VlN2lzMzRpIn0.X2r4dS-W4er8t8iC08aTJQ',

  // Pillar Payment
  VUE_APP_PILLAR_COLLECT_KEY: '64Q6tB-a3PH66-p8sZ83-E96pj6',

  // Dev
  VUE_APP_BACKEND_HOST: 'https://api-green.mycompassionmd.com',
  VUE_APP_WEBRTC_URL: 'https://api-green.mycompassionmd.com',
  VUE_APP_INVITEE_VALIDATION_URL: 'https://green.mycompassionmd.com/invitee',
  VUE_APP_INVITEE_REDIRECT_URL: 'https://green.mycompassionmd.com/invitee',
  VUE_APP_MEDIA_SOUP: 'https://webrtc-dev.mycompassionmd.com',

  // CYPRESS
  // CYPRESS_BASE_URL: 'http://localhost:1024',
  CYPRESS_BASE_URL: 'https://green.mycompassionmd.com',
  // CYPRESS_RECORD_KEY: "6e5c2ebf-48e3-40c8-8e48-60d0d6143594",
  CYPRESS_CLINIC_STRIPE: 'testcy',
  CYPRESS_CLINIC_PILLAR: 'timonpillar',
  CYPRESS_USERNAME_SUPER_ADMIN: 'superadmincy',
  CYPRESS_USERNAME_CLINIC_ADMIN: 'clinicadmincy',
  CYPRESS_USERNAME_PROVIDER1: 'providercy',
  CYPRESS_USERNAME_PATIENT1: 'patientcy',
  CYPRESS_USERNAME_PATIENT_PILLAR: 'timapatientpillar',
  CYPRESS_COMMON_PASSWORD: 'Test2026!',
  CYPRESS_USE_PILLAR: true,

  // Sentry
  VUE_APP_SENTRY_DSN: 'https://4bd2d242b57f54b73a67002679cd612d@o4510827063017472.ingest.us.sentry.io/4511750682378240',
  VUE_APP_SENTRY_ENV: 'fi-green',

  // PostAffiliatePro | Sideqik
  VUE_APP_AFFILIATE_PROGRAM: 'PostAffiliatePro',

  // Sideqik pixel
  VUE_APP_SIDEQIK_LINK: 'https://d1hrk5gt3yn7pi.cloudfront.net/api/sideqik-api-1.4.js',
  VUE_APP_SIDEQIK_HASH: '648d14a1799b350045f2305e',

  // Post Affiliate Pro
  VUE_APP_POST_AFFILIATE_PRO_DOMAIN: 'myguardiandoc.postaffiliatepro.com',
};
